var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import { default as AntDatePicker } from 'antd/lib/date-picker';
import moment from 'moment';
import { isEqual } from 'lodash';
import { globalConfig } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core';
var AntMonthPicker = AntDatePicker.MonthPicker;

var MonthRangePicker = function (_super) {
  __extends(MonthRangePicker, _super);

  function MonthRangePicker(props) {
    var _this = _super.call(this, props) || this;

    _this.disabledStartDate = function (date) {
      var _a = _this.props,
          value = _a.value,
          range = _a.range;
      var end;

      if (value) {
        end = value.end;
      }

      var startLimit;
      var endLimit;

      if (range) {
        startLimit = range.start;
        endLimit = range.end;
      }

      return _this.isDateLimitExceeded(date, startLimit, end || endLimit);
    };

    _this.disabledEndDate = function (date) {
      var _a = _this.props,
          value = _a.value,
          range = _a.range;
      var start;

      if (value) {
        start = value.start;
      }

      var startLimit;
      var endLimit;

      if (range) {
        startLimit = range.start;
        endLimit = range.end;
      }

      return _this.isDateLimitExceeded(date, start || startLimit, endLimit);
    };

    _this.onChange = function (field, value) {
      var _a, _b;

      var format = _this.format;
      var _c = _this.props,
          name = _c.name,
          onChange = _c.onChange,
          range = _c.range;
      var result;

      if (_this.props.value) {
        result = __assign(__assign({}, _this.props.value), (_a = {}, _a[field] = value.format(format), _a));
      } else {
        result = (_b = {}, _b[field] = value.format(format), _b);
      }

      var start = result.start;
      var end = result.end;
      var startLimit;
      var endLimit;

      if (range) {
        startLimit = range.start;
        endLimit = range.end;
      }

      if (start && startLimit) {
        if (moment(startLimit, format) > moment(start, format)) {
          result.start = startLimit;
        }
      }

      if (end && endLimit) {
        if (moment(endLimit, format) < moment(end, format)) {
          result.end = endLimit;
        }
      }

      if (onChange) {
        onChange(result, name);
      }
    };

    _this.onStartChange = function (value) {
      _this.onChange('start', value);
    };

    _this.onEndChange = function (value) {
      _this.onChange('end', value);
    };

    _this.handleStartOpenChange = function (open) {
      if (open) {
        _this.setState({
          startOpen: true
        });
      } else {
        _this.setState({
          startOpen: false,
          endOpen: true
        });
      }
    };

    _this.handleEndOpenChange = function (open) {
      _this.setState({
        endOpen: open
      });
    };

    _this.format = globalConfig.get('format.month') || '';
    _this.state = {
      startOpen: false,
      endOpen: false
    };
    return _this;
  }

  MonthRangePicker.prototype.generateState = function (props) {
    var format = this.format;
    var value = props.value,
        range = props.range;
    var start;
    var end;

    if (value) {
      start = value.start;
      end = value.end;
    }

    var startLimit;
    var endLimit;

    if (range) {
      startLimit = range.start;
      endLimit = range.end;
    }

    var state = {
      start: (start ? moment(start, format) : moment()).startOf('month'),
      end: (end ? moment(end, format) : moment()).startOf('month'),
      startLimit: startLimit ? moment(startLimit, format).startOf('month') : undefined,
      endLimit: endLimit ? moment(endLimit, format).startOf('month') : undefined
    };
    return state;
  };

  MonthRangePicker.prototype.componentWillReceiveProps = function (nextProps) {
    this.setState(this.generateState(nextProps));
  };

  MonthRangePicker.prototype.isDateLimitExceeded = function (date, startLimit, endLimit) {
    var format = this.format;
    var isLimitExceeded = false;
    date = date.startOf('month');

    if (startLimit) {
      isLimitExceeded = moment(startLimit, format) > date;
    }

    if (endLimit) {
      isLimitExceeded = isLimitExceeded || moment(endLimit, format) < date;
    }

    return isLimitExceeded;
  };

  MonthRangePicker.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    return !isEqual(this.props, nextProps) || this.state !== nextState;
  };

  MonthRangePicker.prototype.render = function () {
    var format = this.format;
    var _a = this.props,
        value = _a.value,
        _b = _a.format,
        renderFormat = _b === void 0 ? this.format : _b,
        placeholder = _a.placeholder,
        disabled = _a.disabled;
    var _c = this.state,
        startOpen = _c.startOpen,
        endOpen = _c.endOpen;
    var start;
    var end;

    if (value) {
      start = value.start;
      end = value.end;
    }

    var antValueStart;

    if (start) {
      antValueStart = moment(start, format);
    }

    var antValueEnd;

    if (end) {
      antValueEnd = moment(end, format);
    }

    var placeholderStart = services.language.getText('components.MonthRangePicker.placeholder.start');
    var placeholderEnd = services.language.getText('components.MonthRangePicker.placeholder.end'); // 未设置 placeholder ，则使用默认

    if (placeholder && placeholder.length > 1) {
      placeholderStart = placeholder[0];
      placeholderEnd = placeholder[1];
    }

    return React.createElement("div", {
      className: "month-range-picker"
    }, React.createElement(AntMonthPicker, {
      disabledDate: this.disabledStartDate,
      format: renderFormat,
      value: antValueStart,
      placeholder: placeholderStart,
      onChange: this.onStartChange,
      open: startOpen,
      onOpenChange: this.handleStartOpenChange,
      allowClear: false,
      disabled: disabled
    }), React.createElement("span", {
      className: "spacing"
    }, "~"), React.createElement(AntMonthPicker, {
      disabledDate: this.disabledEndDate,
      format: renderFormat,
      value: antValueEnd,
      placeholder: placeholderEnd,
      onChange: this.onEndChange,
      open: endOpen,
      onOpenChange: this.handleEndOpenChange,
      allowClear: false,
      disabled: disabled
    }));
  };

  return MonthRangePicker;
}(Component);

export { MonthRangePicker };